/**
 * Modal tạo tin BĐS mới trong admin — bọc AdminPropertyForm.
 */
import { AdminPropertyForm } from './AdminPropertyForm';
import { AdminModal } from './AdminModal';
import { TEXT } from '../../shared/languages';

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
  </svg>
);

/**
 * Modal tạo BĐS.
 * @param {Object} props
 * @param {boolean} [props.isOpen]
 * @param {boolean} props.canReviewProperty
 * @param {string} props.userRole
 * @param {Function} props.onClose
 * @param {Function} props.onSaved
 */
export const AdminPropertyCreateModal = ({
  isOpen = false,
  canReviewProperty = false,
  userRole,
  onClose,
  onSaved,
}) => {
  const form = TEXT.property.form;
  const common = TEXT.common;

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      panelClassName="admin-form-modal admin-form-modal--sheet"
      ariaLabelledby="admin-property-create-title"
    >
      <div className="admin-form-modal-header admin-form-sheet-header">
        <div className="admin-form-sheet-handle" aria-hidden="true" />
        <div className="admin-form-sheet-header-row">
          <div>
            <span className="eyebrow">{form.createEyebrow}</span>
            <h2 id="admin-property-create-title">{form.createTitle}</h2>
          </div>
          <button
            type="button"
            className="admin-form-sheet-close"
            aria-label={common.close}
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
      </div>

      {isOpen && (
        <AdminPropertyForm
          key="admin-property-create"
          formId="admin-property-create-form"
          canReviewProperty={canReviewProperty}
          userRole={userRole}
          onSaved={onSaved}
          sheetLayout
        />
      )}
    </AdminModal>
  );
};
